<script setup lang="ts">
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Input } from '@/components/ui/input'
import BaseButton from '@/components/common/BaseButton.vue'
import { useDialog } from '@/composables/useDialog'

const { isOpen, currentDialog, inputValue, handleConfirm, handleCancel } = useDialog()

function handleOpenChange(open: boolean) {
  if (!open && isOpen.value) {
    handleCancel()
  }
}
</script>

<template>
  <AlertDialog :open="isOpen" @update:open="handleOpenChange">
    <AlertDialogContent v-if="currentDialog" class="dialog modal-in bg-surface border-line text-ink-2">
      <AlertDialogHeader>
        <AlertDialogTitle class="text-base font-semibold text-ink">
          {{ currentDialog.title }}
        </AlertDialogTitle>
        <AlertDialogDescription class="text-sm text-ink-4">
          {{ currentDialog.message }}
        </AlertDialogDescription>
      </AlertDialogHeader>

      <div v-if="currentDialog.type === 'prompt'" class="py-2">
        <Input
          v-model="inputValue"
          class="bg-surface-2 border-line-2 text-ink"
          autofocus
          @keydown.enter.prevent="handleConfirm"
        />
      </div>

      <AlertDialogFooter class="flex gap-2 sm:justify-end">
        <BaseButton
          v-if="currentDialog.type !== 'alert'"
          variant="secondary"
          class="dialog-button border-line-2 bg-transparent text-ink-4 hover:bg-surface-2 hover:text-ink"
          @click="handleCancel"
        >
          {{ currentDialog.cancelText || 'Cancel' }}
        </BaseButton>
        <BaseButton
          variant="primary"
          class="dialog-button bg-primary text-primary-foreground font-semibold hover:bg-primary-hover"
          @click="handleConfirm"
        >
          {{ currentDialog.confirmText || 'OK' }}
        </BaseButton>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
